import { Component, Input } from '@angular/core';
import { AccountableItem } from 'app/entities/accountableItem.entity';
import { HelperService } from 'app/services/helper.service';

@Component({
  selector: 'app-accountable-item',
  templateUrl: './item.html',
  styleUrls: ['./item.scss'],
})
export class AccountableItemComponent {

  @Input() item: AccountableItem;

  public helperService = HelperService;
  constructor() { }
}
